import { assert_array_instanceof, assert_string_object_id_not_empty, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__image_asset_category } from '../generation/graph_invoke/_fields/ENUM__image_asset_category';
import { DTO__file_data } from './image_asset_base/DTO__file_data';

export class DTO_REQUEST__images_upload extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_IMAGES_UPLOAD;

  /*
   * FIELDS
   */

  file_data_list: DTO__file_data[];
  workspace_id!: string;
  category!: ENUM__image_asset_category;

  /*
   * METHODS
   */

  constructor() {
    super();

    this.file_data_list = [];
  }

  /*
   * ASSERTS
   */
  assert_standard_fields(): void {
    assert_array_instanceof(this.file_data_list, DTO__file_data);
    assert_string_object_id_not_empty(this.workspace_id);

    assert_type_enum(this.category, ENUM__image_asset_category);
  }
}
